export default function FormFieldsContainer({ children }) {
    return <div className="bg-white py-6 px-4 space-y-6 sm:p-6">{children}</div>;
}
